exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.new-collection[data-v-0e5399c8]{padding-top:0;margin-bottom:0}}@media (max-width: 767px){.new-collection h2[data-v-0e5399c8]{padding:10px 0;font-size:16px}}.logo-box[data-v-0e5399c8]{border-bottom-left-radius:15px;border-bottom-right-radius:15px}\n", ""]);

// exports
